import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import BasicButton from '../../Components/Button_Basic';
import BasicCombo from '../../Components/Combo_Basic';
import BasicModal from '../../Components/Modal_Basic';
import Checking from '../../Components/Checking';
import GridModal from '../../Components/Modal_Grid';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import agCheckbox from '../../Components/agGrid/ag-Checkbox';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';

function Bm10070(props) {
    const gridRef = React.useRef();
    const gridRef1 = React.useRef();
    //그리드 컬럼
    const columnDefs1 = [
        {
            field: 'lanId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LanId' && f.lanType === 'COL')[0].lanName
                    : '', //대표명칭
            editable: false,
        },
        {
            field: 'lanCode',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LanCode' && f.lanType === 'COL')[0].lanName
                    : '', //언어타입
            editable: false,
        },
        {
            field: 'lanName',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LanName' && f.lanType === 'COL')[0].lanName
                    : '', //명칭
        },
        {
            field: 'lanType',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LanType' && f.lanType === 'COL')[0].lanName
                    : '', //타입
        },
    ];
    const [modalToggle, setModalToggle] = React.useState(false); //코드 체크 팝업
    const [modalToggle1, setModalToggle1] = React.useState(false);
    React.useEffect(() => {
        document.title = '언어팩관리';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '기초관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>언어팩관리</strong>" +
            '</h1>';
        if (props.checkInputs.result) {
            gridRef1.current.api.setRowData([
                {
                    lanId: props.checkInputs.lanId,
                    lanCode: props.checkInputs.lanCode,
                    newYn: 'Y',
                },
                ...props.rowData1,
            ]);
            props.setCheckInputs({
                ...props.checkInputs,
                // lanId: "",
                result: false,
            });
        }
    }, [props.checkInputs.result]);
    return (
        <div className="card">
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                }}
            >
                <div style={{ width: '100%' }}>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}
                        ></div>
                        {/* 그리드 버튼  */}
                        <AuthGroupButton
                            pageName="BM10070"
                            target="G02"
                            refreshFunc={() => props.AuthGroupCodeSearch(props.selectedRowData[0].lcategoCd)}
                            addFunc={() => {
                                setModalToggle(true);
                            }}
                            saveFunc={() => props.SaveConfirm('grid1')}
                            deleteFunc={() => props.DeleteConfirm('grid1')}
                        />
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                        {/* 그리드  */}
                        <AgGridReact
                            ref={gridRef1}
                            animateRows={true}
                            columnDefs={columnDefs1}
                            defaultColDef={{
                                flex: 1,
                                minWidth: 100,
                                editable: true,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            rowData={props.rowData1}
                            rowSelection="multiple"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef1, props.setSelectedRowData1)
                            }
                            suppressRowClickSelection={true}
                            onCellValueChanged={(e) =>
                                GridFunctions.onCellValueChanged(e, gridRef1, props.setChangedRowData)
                            }
                            groupDefaultExpanded={1}
                            suppressAggFuncInHeader={true}
                            enableCellChangeFlash={true}
                            getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                        />
                    </div>
                    {/* 코드 체크 팝업 */}
                    {modalToggle && (
                        <BasicModal
                            name={
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_MenuManagement' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : '' //메뉴관리
                            }
                            onClose={() => setModalToggle(false)}
                            buttonName1={
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Check' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '' //검사
                            }
                            execLogic={() => props.CheckKeys()}
                        >
                            <Checking
                                datas={[
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Dia_LanId' && f.lanType === 'DIALOG'
                                                  )[0].lanName
                                                : '', //대표명칭
                                        value: props.checkInputs.lanId,
                                        onChange: (e) => {
                                            props.setCheckInputs({
                                                ...props.checkInputs,
                                                lanId: e.target.value,
                                            });
                                        },
                                    },
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Dia_LanCode' && f.lanType === 'DIALOG'
                                                  )[0].lanName
                                                : '', //언어타입
                                        value: props.checkInputs.lanCode,
                                        onChange: (e) => {
                                            props.setCheckInputs({
                                                ...props.checkInputs,
                                                lanCode: e.target.value,
                                            });
                                        },
                                    },
                                ]}
                            />
                        </BasicModal>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Bm10070;
